import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var _excluded = ["in", "unmountOnExit", "animateOpacity", "startingHeight", "endingHeight", "style", "className", "transition", "transitionEnd"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { TRANSITION_EASINGS, withDelay } from "./chunk-LB6CWFOC.mjs";

// src/collapse.tsx
import { cx, warn } from "@chakra-ui/shared-utils";
import { AnimatePresence, motion } from "framer-motion";
import { forwardRef, useEffect, useState } from "react";
import { jsx } from "react/jsx-runtime";
var isNumeric = function isNumeric(value) {
  return value != null && parseInt(value.toString(), 10) > 0;
};
var defaultTransitions = {
  exit: {
    height: {
      duration: 0.2,
      ease: TRANSITION_EASINGS.ease
    },
    opacity: {
      duration: 0.3,
      ease: TRANSITION_EASINGS.ease
    }
  },
  enter: {
    height: {
      duration: 0.3,
      ease: TRANSITION_EASINGS.ease
    },
    opacity: {
      duration: 0.4,
      ease: TRANSITION_EASINGS.ease
    }
  }
};
var variants = {
  exit: function exit(_ref) {
    var animateOpacity = _ref.animateOpacity,
      startingHeight = _ref.startingHeight,
      transition = _ref.transition,
      transitionEnd = _ref.transitionEnd,
      delay = _ref.delay;
    var _a;
    return _objectSpread(_objectSpread({}, animateOpacity && {
      opacity: isNumeric(startingHeight) ? 1 : 0
    }), {}, {
      height: startingHeight,
      transitionEnd: transitionEnd == null ? void 0 : transitionEnd.exit,
      transition: (_a = transition == null ? void 0 : transition.exit) != null ? _a : withDelay.exit(defaultTransitions.exit, delay)
    });
  },
  enter: function enter(_ref2) {
    var animateOpacity = _ref2.animateOpacity,
      endingHeight = _ref2.endingHeight,
      transition = _ref2.transition,
      transitionEnd = _ref2.transitionEnd,
      delay = _ref2.delay;
    var _a;
    return _objectSpread(_objectSpread({}, animateOpacity && {
      opacity: 1
    }), {}, {
      height: endingHeight,
      transitionEnd: transitionEnd == null ? void 0 : transitionEnd.enter,
      transition: (_a = transition == null ? void 0 : transition.enter) != null ? _a : withDelay.enter(defaultTransitions.enter, delay)
    });
  }
};
var Collapse = forwardRef(function (props, ref) {
  var isOpen = props.in,
    unmountOnExit = props.unmountOnExit,
    _props$animateOpacity = props.animateOpacity,
    animateOpacity = _props$animateOpacity === void 0 ? true : _props$animateOpacity,
    _props$startingHeight = props.startingHeight,
    startingHeight = _props$startingHeight === void 0 ? 0 : _props$startingHeight,
    _props$endingHeight = props.endingHeight,
    endingHeight = _props$endingHeight === void 0 ? "auto" : _props$endingHeight,
    style = props.style,
    className = props.className,
    transition = props.transition,
    transitionEnd = props.transitionEnd,
    rest = _objectWithoutProperties(props, _excluded);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    mounted = _useState2[0],
    setMounted = _useState2[1];
  useEffect(function () {
    var timeout = setTimeout(function () {
      setMounted(true);
    });
    return function () {
      return clearTimeout(timeout);
    };
  }, []);
  warn({
    condition: Number(startingHeight) > 0 && !!unmountOnExit,
    message: "startingHeight and unmountOnExit are mutually exclusive. You can't use them together"
  });
  var hasStartingHeight = parseFloat(startingHeight.toString()) > 0;
  var custom = {
    startingHeight: startingHeight,
    endingHeight: endingHeight,
    animateOpacity: animateOpacity,
    transition: !mounted ? {
      enter: {
        duration: 0
      }
    } : transition,
    transitionEnd: {
      enter: transitionEnd == null ? void 0 : transitionEnd.enter,
      exit: unmountOnExit ? transitionEnd == null ? void 0 : transitionEnd.exit : _objectSpread(_objectSpread({}, transitionEnd == null ? void 0 : transitionEnd.exit), {}, {
        display: hasStartingHeight ? "block" : "none"
      })
    }
  };
  var show = unmountOnExit ? isOpen : true;
  var animate = isOpen || unmountOnExit ? "enter" : "exit";
  return /* @__PURE__ */jsx(AnimatePresence, {
    initial: false,
    custom: custom,
    children: show && /* @__PURE__ */jsx(motion.div, _objectSpread(_objectSpread({
      ref: ref
    }, rest), {}, {
      className: cx("chakra-collapse", className),
      style: _objectSpread({
        overflow: "hidden",
        display: "block"
      }, style),
      custom: custom,
      variants: variants,
      initial: unmountOnExit ? "exit" : false,
      animate: animate,
      exit: "exit"
    }))
  });
});
Collapse.displayName = "Collapse";
export { Collapse };